import React, { useState } from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/containers/accordion.containers';
import AddNewForumPost from './forumpost.component';
import { deepCopy } from '../../../../../common/services/common.service';
import Popup from '../../../../../common/components/popup';
import { selectListItems } from '../../../../../redux/library/selector';
import { useSelector } from 'react-redux';

export default function FroumGroupsValuesComponent({ selectedTopic,handleLike,handleDislike, setSelectedTopic,closeModal,setAddItem,addItem,selectedCommunity ,handleSaveItem}: any) {
  const forumGroups = selectedCommunity?.ForumGroups ?? [];

  const [expandedForumIds, setExpandedForumIds] = useState<number[]>([]);
  const [expandedTopicIds, setExpandedTopicIds] = useState<number[]>([]);
  const [showModal, setShowModal] = useState(false);

  const libraryData = useSelector(selectListItems)
 

const getTopicTypeText = (value: number) => {
  const type = libraryData?.result?.ForumTopicType?.find(
    (item: any) => item.Value === value
  );
  return type?.Text || '';
};

	const HTMLContent: any = ({ htmlContent }: any) => {
		return (
			<div
				dangerouslySetInnerHTML={{ __html: htmlContent }}
			/>
		);
	};


  const toggleForum = (forumId: number) => {
    setExpandedForumIds(prev =>
      prev.includes(forumId) ? prev.filter(id => id !== forumId) : [...prev, forumId]
    );
  };

  const toggleTopic = (topicId: number) => {
    setExpandedTopicIds(prev =>
      prev.includes(topicId) ? prev.filter(id => id !== topicId) : [...prev, topicId]
    );
  };

  const handleAddPost = (topic: any) => {

    setSelectedTopic(topic);
    setShowModal(true);
     setAddItem({
      id: 0
    });


  };

 
  
   // Modal Function
  const NewItemPopup = ({ handleSaveItem }: any) => {
    const [localItems, setLocalItems] = useState(deepCopy(selectedTopic));
    const handleLocalFormChange = (value: any, field: any) => {
      setLocalItems((prev: any) => ({
        ...prev,
        [field]: value,
      }));
    };
    const handleItemSubmit = () => {
      setLocalItems(localItems);
      handleSaveItem(localItems)
    };
    return (
      <>
        <Popup onClose={closeModal}>
          <AddNewForumPost
            Close={closeModal}
            handleItemSubmit={handleItemSubmit}
            selectedForumPosts={localItems}
            onInnerBasicFormChange={handleLocalFormChange}

          />

        </Popup>
      </>
    )
  }




  return (
    <>
      <div className="max-w-5xl mx-auto px-4 py-6">
        <AccordionContainer
          expandedPanel="userInfo"
          child={
            <div className="space-y-10">
              {forumGroups.map((group: any, idx: number) => (
                <div
                  key={idx}
                  className="bg-white p-6 rounded-xl border border-gray-300 shadow-md"
                >
                  <h2 className="text-3xl font-bold text-indigo-900 mb-2">{group?.Name}</h2>
                  <p className="text-base text-gray-700 mb-5">{group.Description}</p>
                  

                  {group.Forums?.length > 0 ? (
                    <div className="space-y-5">
                      {group.Forums.map((forum: any) => (
                        <div key={forum.Id} className="border rounded-xl p-4 bg-gray-50">
                          <div
                            className="cursor-pointer text-xl font-semibold text-orange-700 hover:text-orange-900"
                            onClick={() => toggleForum(forum.Id)}
                          >
                            {forum.Name}
                          </div>
                          <p className="text-sm text-gray-600 mb-2">{forum.Description}</p>
                           <p className="text-sm text-gray-500 mt-1">
                                    Topics: {forum?.NumTopics || 0}  | Posts: {forum?.NumPosts || 0}
                                    </p>

                          {expandedForumIds.includes(forum.Id) && (
                            <div className="ml-4 mt-3 space-y-4">
                              {forum.ForumTopics?.length > 0 ? (
                                forum.ForumTopics.map((topic: any) => (
                                  <div key={topic.Id} className="border rounded-lg p-4 bg-white">
                                    <div
                                      className="cursor-pointer text-lg font-medium text-indigo-800 hover:text-indigo-900"
                                      onClick={() => toggleTopic(topic.Id)}
                                    >
                                      {topic.Subject}
                                    </div>
                                    <p className="text-sm text-gray-500 mt-1">

                                      Posts: {topic.NumPosts} | Views: {topic.Views} | Topic Type: {getTopicTypeText(topic.TopicTypeId)}
                                    </p>

                                    {expandedTopicIds.includes(topic.Id) && (
                                      <div className="ml-4 mt-3 space-y-3">
                                        {topic?.ForumPosts?.length > 0 ? (
                                          topic.ForumPosts.map((post: any) => (
                                            <div key={post.Id} className="bg-gray-100 border p-3 rounded-md">
                                              <p className="text-sm text-gray-800">
                                               
                                                <HTMLContent htmlContent={post ? post.Text : ''} /></p>
                                       <p className="text-sm text-gray-600 mt-2 flex items-center space-x-4">
  <span className="inline-flex items-center space-x-1"> 
    <svg   onClick={() => handleLike(post.Id)}  className="cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none">
      <path d="M2 12.5C2 11.3954 2.89543 10.5 4 10.5C5.65685 10.5 7 11.8431 7 13.5V17.5C7 19.1569 5.65685 20.5 4 20.5C2.89543 20.5 2 19.6046 2 18.5V12.5Z" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.4787 7.80626L15.2124 8.66634C14.9942 9.37111 14.8851 9.72349 14.969 10.0018C15.0369 10.2269 15.1859 10.421 15.389 10.5487C15.64 10.7065 16.0197 10.7065 16.7791 10.7065H17.1831C19.7532 10.7065 21.0382 10.7065 21.6452 11.4673C21.7145 11.5542 21.7762 11.6467 21.8296 11.7437C22.2965 12.5921 21.7657 13.7351 20.704 16.0211C19.7297 18.1189 19.2425 19.1678 18.338 19.7852C18.2505 19.8449 18.1605 19.9013 18.0683 19.9541C17.116 20.5 15.9362 20.5 13.5764 20.5H13.0646C10.2057 20.5 8.77628 20.5 7.88814 19.6395C7 18.7789 7 17.3939 7 14.6239V13.6503C7 12.1946 7 11.4668 7.25834 10.8006C7.51668 10.1344 8.01135 9.58664 9.00069 8.49112L13.0921 3.96056C13.1947 3.84694 13.246 3.79012 13.2913 3.75075C13.7135 3.38328 14.3652 3.42464 14.7344 3.84235C14.774 3.8871 14.8172 3.94991 14.9036 4.07554C15.0388 4.27205 15.1064 4.37031 15.1654 4.46765C15.6928 5.33913 15.8524 6.37436 15.6108 7.35715C15.5838 7.46692 15.5488 7.5801 15.4787 7.80626Z" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    <span>{post.LikeVoteCount || 0}</span>
  </span>
  <span className="inline-flex items-center space-x-1">
    <svg  onClick={() => handleDislike(post.Id)} className="cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none">
      <path d="M2 11.5C2 12.6046 2.89543 13.5 4 13.5C5.65685 13.5 7 12.1569 7 10.5V6.5C7 4.84315 5.65685 3.5 4 3.5C2.89543 3.5 2 4.39543 2 5.5V11.5Z" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.4787 16.1937L15.2124 15.3337C14.9942 14.6289 14.8851 14.2765 14.969 13.9982C15.0369 13.7731 15.1859 13.579 15.389 13.4513C15.64 13.2935 16.0197 13.2935 16.7791 13.2935H17.1831C19.7532 13.2935 21.0382 13.2935 21.6452 12.5327C21.7145 12.4458 21.7762 12.3533 21.8296 12.2563C22.2965 11.4079 21.7657 10.2649 20.704 7.9789C19.7297 5.88111 19.2425 4.83222 18.338 4.21485C18.2505 4.15508 18.1605 4.0987 18.0683 4.04586C17.116 3.5 15.9362 3.5 13.5764 3.5H13.0646C10.2057 3.5 8.77628 3.5 7.88814 4.36053C7 5.22106 7 6.60607 7 9.37607V10.3497C7 11.8054 7 12.5332 7.25834 13.1994C7.51668 13.8656 8.01135 14.4134 9.00069 15.5089L13.0921 20.0394C13.1947 20.1531 13.246 20.2099 13.2913 20.2493C13.7135 20.6167 14.3652 20.5754 14.7344 20.1577C14.774 20.1129 14.8172 20.0501 14.9036 19.9245C15.0388 19.728 15.1064 19.6297 15.1654 19.5323C15.6928 18.6609 15.8524 17.6256 15.6108 16.6429C15.5838 16.5331 15.5488 16.4199 15.4787 16.1937Z" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    <span>{post.DisLikeVoteCount || 0}</span>
  </span>
</p>

                                            </div>
                                          ))
                                        ) : (
                                          <p className="text-sm italic text-gray-400">
                                            No posts yet.
                                          </p>
                                        )}

                                        <button
                                          className="mt-2 text-sm text-white bg-indigo-600 hover:bg-indigo-700 px-4 py-2 rounded-md"
                                          onClick={() => handleAddPost(topic)}
                                        >
                                          + Add New Post
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                ))
                              ) : (
                                <p className="text-sm text-gray-400 italic">
                                  No topics in this forum.
                                </p>
                              )}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-gray-500 italic">No forums available in this group.</p>
                  )}
                </div>
              ))}
            </div>
          }
        />
      </div>

   {
                addItem ? <NewItemPopup handleSaveItem={handleSaveItem} /> : <></>
            }
    </>
  );
}
